import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { Button, CheckBox, InputField, TitleLarge } from '../../components';
import { DELETE_ICON, SAVE_ICON } from '../../utils/consts';

const UserDetailPage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Benutzer</TitleLarge>
					<div className='container my-4'>
						<div className='row justify-content-center'>
							<form className='col-12 col-sm-8 col-xl-7'>
								<InputField
									id={'first_name'}
									classes={'background-secondary'}
									type={'text'}
									label={'Vorname'}
									value={'Nikolay'}
									onChange={() => {}}
								/>
								<InputField
									id={'last_name'}
									classes={'background-secondary'}
									type={'text'}
									label={'Nachname'}
									value={'Malygin'}
									onChange={() => {}}
								/>
								<InputField
									id={'email'}
									classes={'background-secondary'}
									type={'email'}
									label={'E-Mail'}
									value={'Nikolay.Malygin@htlpinkafeld.at'}
									onChange={() => {}}
								/>
								<InputField
									id={'password'}
									classes={'background-secondary'}
									type={'password'}
									label={'Passwort ändern'}
								/>
								<CheckBox
									id={'is_admin'}
									label={'Administrator'}
									classes={'background-tertiary'}
								/>
								<CheckBox
									id={'is_disabled'}
									label={'Gesperrt'}
									classes={'background-tertiary'}
								/>
								<div className='d-flex justify-content-end mt-4 gap-3'>
									<Button classes={'background-red px-4 py-2'} icon={DELETE_ICON}>
										Löschen
									</Button>
									<Button classes={'background-blue px-4 py-2'} icon={SAVE_ICON}>
										Speichern
									</Button>
								</div>
							</form>
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default UserDetailPage;
